const KLAVIYO_BASE_URL = "https://a.klaviyo.com";
const BIS_ENDPOINT = "/client/back-in-stock-subscriptions/";

class Klaviyo {
	constructor() {
		this.publicKey = window.klaviyo.key;
		this.listId = window.klaviyo.listIdBIS;
	}

	backInStockSubscribe({ email, variant, subscribe = false }) {
		return new Promise((resolve, reject) => {
			if (this.publicKey == '') {
				reject('Klaviyo Public Key not set in theme settings');
				return;
			}
			const payload = {
				data: {
                    "type": "back-in-stock-subscription",
					"attributes": {
                        "channels": ["EMAIL"],
                        "profile": {
                            "data": {
                                "type": "profile",
                                "attributes": {
                                    "email": email
                                }
                            }
                        }
					},
                    "relationships": {
                        "variant": {
                            "data": {
                                "type": "catalog-variant",
						        id: `$shopify:::$default:::${ variant }`
					        }
				        }
					}
				}
			}

			if (subscribe) {
                console.log('subscribe', subscribe);
			// 	if (this.listId == '') {
			// 		reject('Klaviyo newsletter list ID not set in theme settings');
			// 		return;
			// 	}
			// 	payload.g = this.listId;
			// 	payload.subscribe_for_newsletter = true;
			}
			
			try {
				fetch(`${ KLAVIYO_BASE_URL }${ BIS_ENDPOINT }?company_id=${ this.publicKey }`, {
                    method: 'POST',
                    headers: {
                      "Content-Type": "application/json",
                      "revision":"2024-06-15"
                    },
                    body: JSON.stringify(payload),
                }).then(result =>{
                    console.log('result', result);
                    resolve(result)
                }).catch(error => console.log('error', error));

			} catch (e) {
				reject(e);
			}
		});
	}
}


if (!customElements.get("klaviyo-popup")) {
	class KlaviyoPopup extends ModalDialog {
	  constructor() {
		super();

	  }
  
	}
	customElements.define("klaviyo-popup", KlaviyoPopup);
  }
  